module.exports = __webpack_public_path__ + "img/_54A2212_t.020b9b4d.jpg";